var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0859375 10.7891L1.85156 5.5L0.0859375 0.210938L15.9531 5.5L0.0859375 10.7891ZM2.73438 5H11.2969L1.66406 1.78906L2.73438 5ZM1.66406 9.21094L11.2969 6H2.73438L1.66406 9.21094Z",
    fill: "#333333"
  })));
};
export default SvgSend;